import { gql } from '@apollo/client';
export const GET_TWO_WHEELER_POLICY_VAR_DETAILS = gql`
  query getTwoWheelerPolicyVarDetails {
    motorQuote @client
    selectedIntermediary @client
  }
`;

// export const GET_PCV_POLICY_VAR_DETAILS = gql`
// query getTwoWheelerPolicyVarDetails {
//   motorQuote @client
//   selectedIntermediary @client
// }
// `;

export const INTERMEDIARY_LIST = gql`
  query IntermediaryList {
    myIntermediaries {
      intermediaryName
      intermediaryCode
      isSelected
      businessLocations {
        code
        name
      }
    }
  }
`;

export const LOOKUP_FIELDUSER = gql`
  query lookupFieldUser($filter: UserSearchFilter) {
    associatedEntityLookup(filter: $filter) {
      fieldUserName
    }
  }
`;

export const GET_FIELDUSER_LIST = gql`
  query getFiledUserByIMID($input: FiledUserByIMID) {
    getFiledUserByIMID(input: $input) {
      fieldUserCode
      fieldUserName
    }
  }
`;

export const PREVIOUS_POLICY_DROPDOWN_DETAILS = gql`
  query previousPolicyDropdownDetails($productCode: StrictNumber) {
    PRD_PreviousPolicyTypeList(productCode: $productCode) {
      code
      value
    }
    PRD_PreviousPolicyTermList(productCode: $productCode) {
      code
      value
    }
  }
`;

export const DISCOUNT_DROPDOWN_DETAILS = gql`
  query discountDropdownDetails($productCode: StrictNumber) {
    PRD_idProofTypeList(productCode: $productCode) {
      code
      value
    }
    PRD_vehicleOwnedByList(productCode: $productCode) {
      code
      value
    }
    PRD_IDProofTypeForCreditScoreList(productCode: $productCode) {
      code
      value
    }
    PRD_VoluntaryDeductibleAmount(productCode: $productCode) {
      code
      value
    }
  }
`;

export const PREVIOUS_CLAIMS_DROPDOWN_DETAILS = gql`
  query previousClaimsDropdownDetails($productCode: StrictNumber) {
    PRD_TotalClaimCountList(productCode: $productCode) {
      code
      value
    }
    PRD_NoOfClaimsInYear1List(productCode: $productCode) {
      code
      value
    }
    PRD_NoOfClaimsInYear2List(productCode: $productCode) {
      code
      value
    }
    PRD_NoOfClaimsInYear3List(productCode: $productCode) {
      code
      value
    }
    PRD_PreviousYearNCBSlabList(productCode: $productCode) {
      code
      value
    }
  }
`;

export const MODEL_DETAILS = gql`
  query modelDetails($filter: ModelList) {
    modelList(filter: $filter) {
      code
      value
    }
  }
`;

export const VARIANT_DETAILS = gql`
  query variantDetails($filter: VariantFilter) {
    variantList(filter: $filter) {
      variantCode
      variantName
      carryingCapacity
      seatingCapacity
      cubeCapacity
      fuel
      gvw
      bodyType
    }
  }
`;

export const PRODUCT_TYPE_LIST = gql`
  query productTypeList {
    lobProductList {
      lob_name
      lob_code
      products {
        product_name
        product_code
        product_types {
          code
          value
        }
        linkTo
        display_name
      }
    }
  }
`;

export const CAR_SECURE_BUSINESS_TYPE = gql`
  query getPCVBusinessType($filter: BusinessTypeInput) {
    getPCVBusinessType(filter: $filter) {
      code
      value
    }
  }
`;

export const INSURED_DECLARED_VALUE = gql`
  query insuredDeclaredValue($input: InsuredDeclareValInput) {
    insuredDeclaredValue(input: $input) {
      suggestedIDV
      minSuggestedIDV
      maxSuggestedIDV
      irfPctMin
      idvPctMin
      irfPctMax
      idvPctMax
    }
  }
`;

export const APPLICABLE_COVERS = gql`
  query applicableCovers($input: ApplicableCoversInput) {
    applicableCovers(input: $input) {
      tenure
      riskCovers {
        riskType
        covers {
          name
          index
          selected
          attributes {
            name
            value
            displayName
            fieldType
            fieldDataType
            defaultValue
            showOnScreen
            dataValues {
              code
              value
            }
          }
        }
      }
    }
  }
`;

export const RTO_LIST_BRAND_LIST_YEAR_RANGE = gql`
  query rtoBrandYearInfo(
    #$filterRTOList: RtoLocInput
    $filterMakeList: MakeList
    $type: String
  ) {
    #rtoList(filter: $filterRTOList) {
    #  rtoLocCode
    #  rtoLocDesc
    #  rtoAuthCode
    #}
    makeList(filter: $filterMakeList) {
      code
      value
    }
    yearRange(type: $type) {
      minYr
      maxYr
    }
  }
`;

export const VEHICLE_DETAILS = gql`
  query getVehicleDetails($input: RegInput) {
    getVehicleDetails(input: $input) {
      make {
        code
        value
      }
      model {
        code
        value
      }
      variant {
        code
        value
      }
      fuelType
      seatingCapacity
      cubicCapacity
      carryingCapacity
      rto {
        rtoAuthCode
        rtoLocCode
        rtoLocDesc
      }
      manufactureYear
      regPurchaseDate
      engineNumber
      chasisNumber
      financerName
      prevInsurance {
        insurerName
        policyNumber
        expiryDate
        startDate
        coverType
        policyTenure
      }
    }
  }
`;

export const CLAIM_DETAILS = gql`
  query getClaimDetails($input: RegInput) {
    getClaimDetails(input: $input) {
      totalClaimCount
      claimsInYear1
      claimsInYear2
      claimsInYear3
      prevNCBSlab
      totalClaimAmount
    }
  }
`;

export const PINCODE_LOOKUP = gql`
  query customerAddress($filter: PincodeFilter) {
    pincodeInfo(filter: $filter) {
      cityCode
      city
      districtCode
      district
      pinCode
      pinCodeLocality
      stateCode
      state
      countryCode
      country
    }
  }
`;

export const CALCULATE_PREMIUM = gql`
  query calculatePremiumQuotePCV(
    $input: gcvCalculatePremiumQuoteInput
  ) {
    calculatePremiumQuotePCV(input: $input) {
      p_startdate
      p_enddate
      idv1
      idv2
      idv3
      netODPremium
      netTPPremium
      loadingDiscount
      netPremium
      gst
      stampDuty
      totalPremium
      loading {
        name
        amount
      }
      discount {
        name
        amount
      }
      vehicleAge
      claimFreeYear
      creditScore
      warningMsg
      NCB
      QuotationRecordNo
    }
  }
`;

export const CUSTOMER_DROPDOWN_DETAILS = gql`
  query customerDropdownDetailsDetails {
    organisationList {
      code
      value
    }
    salutationList {
      code
      value
      gender
    }
    genderList {
      code
      value
    }
  }
`;

export const GET_CUSTOMER_TYPE_DOMAIN = gql`
  query getCustomerTypeDomain {
    customerTypeList {
      code
      value
    }
  }
`;

export const SEARCH_CUSTOMERS = gql`
  query searchCustomers($filter: CustomerFilter) {
    _customer_meta(filter: $filter) {
      resultCount
      maxRow
      infoMessages
      metaMessage {
        type
        header
        message
      }
    }
    customers(filter: $filter) {
      cust_type {
        code
        value
      }
      cust_number
      indv_detail {
        full_name
        gender {
          code
          value
        }
      }
      org_detail {
        org_name
      }
      contact {
        email
        mobile
      }
      permanent_address {
        location
      }
    }
  }
`;

// export const SAVE_QUOTE_PCV = gql`
//   mutation saveQuoteTW($input: TWQuoteInput) {
//     saveQuoteTW(input: $input) {
//       quoteNumber
//       quoteCreationDate
//       status
//     }
//   }
// `;

// export const SEND_QUOTE_EMAIL_PCV_ALERT = gql`
//   mutation sendQuoteEmailTW(
//     $input: TWQuoteInput
//     $email: String
//     $quoteNumber: String
//     $ccEmailIds: [String]
//   ) {
//     sendQuoteEmailTW(
//       input: $input
//       email: $email
//       quoteNumber: $quoteNumber
//       ccEmailIds: $ccEmailIds
//     ) {
//       message
//     }
//   }
// `;

// export const SEND_QUOTE_SMS_PCV_ALERT = gql`
//   mutation sendQuoteSMSTW(
//     $input: TWQuoteInput
//     $mobile: String
//     $quoteNumber: String
//     $alternateMobileNos: [String]
//     $whatsappNo: String
//     $modes: [String]
//   ) {
//     sendQuoteSMSTW(
//       input: $input
//       mobile: $mobile
//       quoteNumber: $quoteNumber
//       alternateMobileNos: $alternateMobileNos
//       whatsappNo: $whatsappNo
//       modes: $modes
//     ) {
//       message
//     }
//   }
// `;

// export const SEND_QUOTE_PDF_PCV = gql`
//   mutation sendQuotePDFTW(
//     $input: TWQuoteInput
//     $quoteNumber: String
//   ) {
//     sendQuotePDFTW(input: $input, quoteNumber: $quoteNumber) {
//       base64Pdf
//     }
//   }
// `;

export const CHARACTER_LIMIT_LIST = gql`
  query characterLimitList {
    characterLimitList {
      code
      value
    }
  }
`;
export const MOBILE_NUMBER_STARTING_WITH = gql`
  query mobileNumberStartingWith {
    mobileNumberStartingWith {
      code
      value
    }
  }
`;
export const POLICY_EXPIRY_DATE = gql`
  query policyExpiryDate($input: policyStartDate) {
    policyExpireDate(input: $input) {
      expireDate
    }
  }
`;






export const PRODUCT_VARIANT = gql`
  query productvariant($input: DomainInput) {
    getDomainData(input: $input) {
      code
      value
    }
  }
`;
export const GET_PCV_POLICY_VAR_DETAILS = gql`
query getTwoWheelerPolicyVarDetails {
  motorQuote @client
  selectedIntermediary @client
}
`;
export const SAVE_QUOTE_PCV = gql`
  mutation saveQuoteTW($input: TWQuoteInput) {
    saveQuoteTW(input: $input) {
      quoteNumber
      quoteCreationDate
      status
    }
  }
`;
export const SEND_QUOTE_EMAIL_PCV_ALERT = gql`
  mutation sendQuoteEmailTW(
    $input: TWQuoteInput
    $email: String
    $quoteNumber: String
    $ccEmailIds: [String]
  ) {
    sendQuoteEmailTW(
      input: $input
      email: $email
      quoteNumber: $quoteNumber
      ccEmailIds: $ccEmailIds
    ) {
      message
    }
  }
`;
export const SEND_QUOTE_SMS_PCV_ALERT = gql`
  mutation sendQuoteSMSTW(
    $input: TWQuoteInput
    $mobile: String
    $quoteNumber: String
    $alternateMobileNos: [String]
    $whatsappNo: String
    $modes: [String]
  ) {
    sendQuoteSMSTW(
      input: $input
      mobile: $mobile
      quoteNumber: $quoteNumber
      alternateMobileNos: $alternateMobileNos
      whatsappNo: $whatsappNo
      modes: $modes
    ) {
      message
    }
  }
`;
export const SEND_QUOTE_PDF_PCV = gql`
  mutation sendQuotePDFTW(
    $input: TWQuoteInput
    $quoteNumber: String
  ) {
    sendQuotePDFTW(input: $input, quoteNumber: $quoteNumber) {
      base64Pdf
    }
  }
`;
export const GET_BUSINESS_TYPE_PCV = gql`
  query businessTypePCV($input: DomainInput) {
    getDomainData(input: $input) {
      code
      value
    }
  }
`;
export const GET_CARRIAGE_PCV = gql`
  query carriageTypePCV($input: DomainInput) {
    getDomainData(input: $input) {
      code
      value
    }
  }
`;
export const GET_USAGE_TYPE_PCV = gql`
  query usageTypePCV($input: DomainInput) {
    getDomainData(input: $input) {
      code
      value
    }
  }
`;
export const GET_TYPE_OF_CARRIAGE_PCV = gql`
  query typeOfCarriagePCV($input: DomainInput) {
    getDomainData(input: $input) {
      code
      value
    }
  }
`;
export const GET_PERMIT_PCV = gql`
  query permitTypePCV($input: DomainInput) {
    getDomainData(input: $input) {
      code
      value
    }
  }
`;
export const GET_TOWEDBY_PCV = gql`
  query permitTypePCV($input: DomainInput) {
    getDomainData(input: $input) {
      code
      value
    }
  }
`;
export const GET_NO_OFTRAILERS_PCV = gql`
  query permitTypePCV($input: DomainInput) {
    getDomainData(input: $input) {
      code
      value
    }
  }
`;
export const GET_VEHICLEUSE_PCV = gql`
  query permitTypeGCV($input: DomainInput) {
    getDomainData(input: $input) {
      code
      value
    }
  }
`;
export const GET_SUBPRODUCT_PCV = gql`
  query permitTypeGCV($input: DomainInput) {
    getDomainData(input: $input) {
      code
      value
    }
  }
`;
export const FETCH_ROLE = gql`
  query fetchRole {
    checkAuth {
      role {
        roleName
      }
    }
  }
`;

export const GET_RTO_DETAILS = gql`
  query getRtoDetails($input: RtoSearchInput ) {
    RTODtlsSearch(input: $input) {
      rto {
        rtoAuthCode
        rtoLocCode
        rtoLocDesc
      }
    }
  }
`;